// Owner: account-settings (plan §3.3). Workflows left Settings: they are Automations, with their own
// place in the rail. Old links and bookmarks land there.
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_settings/settings/workflows')({
  beforeLoad: () => {
    throw redirect({ to: '/automations', replace: true });
  },
});
